import React, { Component } from "react";
import Moment from 'moment';
import bannerImage from "../../../../../img/default-banner-bg.png";
import ProfileImage from "../../../../../img/AT&T.png";
import Icon from "../../../icon";
import ButtonIcon from "../../../button";
export class AdminHeader extends Component {
    
    render(){      
        return(
            <div className="subscription-overview-wrapper internal-overview-wrapper">
                <div className="subscription-overview-container">
                    <div className="subscription-header-container">
                        <img className="banner-image" src={bannerImage} alt="banner" />
                        <div className="edit-icon-container">
                            <Icon customClassName="icon-left" name="pen-light" size="25px" color="#fff" />
                        </div>
                        <div className="subscription-header-content">
                            <h1 className="subscription-title">{this.props.title}</h1>
                            <div className="subscription-time-container">
                                <h2 className="subscriptiion-date-time">{Moment.utc(new Date()).format('ddd, MMMM DD, YYYY')}</h2>
                                <span className="subscriptiion-date-time">|</span>
                                <h2 className="subscriptiion-date-time">{Moment().format('hh:mm a')}</h2>
                            </div>
                        </div>
                        <div className="subscription-client-logo">
                            <img
                                src={ ProfileImage }
                                alt="client"
                            />
                        </div>
                    </div>
                    <div className="subscription-user-info">
                        <h3>{this.props.username}</h3>
                        <div className="subscription-user-badge">
                            <span>{this.props.badge}</span>
                        </div>
                    </div>
                    <div className="horizontal-separator"></div>
                    <div className="subscription-detail-container">
                        <div>
                            <h4>Hello, {this.props.firstname}!</h4>
                            <span>{this.props.message}</span>
                        </div>
                        <div className="subscription-btn-container">
                            <ButtonIcon onClick={()=>alert("click")} iconLeft="file-excel" iconSize="17px" customClassName="subscription-export-btn" labelName="Export Report"/> 
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}